import { useRegisterSW } from "virtual:pwa-register/react";
import { RefreshCw, X } from "lucide-react";
import { Button } from "../ui/Button";
import { useUiStore } from "../../app/store/ui-store";

export function PwaUpdateNotice() {
  const { needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW();
  const draftDirty = useUiStore((state) => Object.values(state.dirtySources).some(Boolean));
  if (!needRefresh) return null;
  return (
    <div className="update-notice" role="status">
      <div>
        <strong>An update is ready</strong>
        <span>{draftDirty ? "Save or close your draft before updating." : "The update does not intentionally clear your workspace; backups remain important."}</span>
      </div>
      <Button size="sm" disabled={draftDirty} icon={<RefreshCw size={15} />} onClick={() => void updateServiceWorker(true)}>Update</Button>
      <button className="icon-button" aria-label="Dismiss update" onClick={() => setNeedRefresh(false)}><X size={17} /></button>
    </div>
  );
}
